import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import PropTypes from "prop-types"
import { OrderType } from "@pathwright/graphql-client/src/generated"
import { useCurrencyFormatter } from "../../currency/CurrencyFormatterProvider"
import OrderStripeCheckoutForm from "../../order/OrderStripeCheckoutForm"
import { getResourceTypeLabel } from "../../resource/utils"

const LicenseResourcePrivateCohortsForm = ({
  licenseOffering,
  price,
  licensorSchool,
  cohortName,
  discountCode,
  seatCount
}) => {
  const { t, tc } = useTranslate()
  const { currencyFormatter } = useCurrencyFormatter()

  let submitLabel =
    price > 0
      ? t("resource.licensing_form.get_curriculum_payment", {
          payment: currencyFormatter.customFormat(price)
        })
      : t("Get {{ resourceType }}", {
          resourceType: getResourceTypeLabel(
            licenseOffering.resource.resource_type,
            tc
          )
        })

  return (
    <OrderStripeCheckoutForm
      schoolId={licensorSchool.id}
      submitLabel={submitLabel}
      disabled={!cohortName}
      orderType={OrderType.GroupLicense}
      orderData={{
        license_offering_id: licenseOffering.id,
        name: cohortName,
        role: licenseOffering.register_creator_as,
        seat_count: seatCount,
        coupon_code: discountCode || undefined
      }}
    />
  )
}

LicenseResourcePrivateCohortsForm.displayName =
  "LicenseResourcePrivateCohortsForm"

LicenseResourcePrivateCohortsForm.propTypes = {
  licenseOffering: PropTypes.object.isRequired,
  licensorSchool: PropTypes.object.isRequired,
  setDiscountCode: PropTypes.func.isRequired,
  setSeatCount: PropTypes.func.isRequired,
  computedDiscount: PropTypes.object,
  seatCount: PropTypes.number
}

export default LicenseResourcePrivateCohortsForm
